var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaymentsReports = function SvgPaymentsReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M14.1 12h2c.6 0 1 .4 1 1h2c0-1.7-1.3-3-3-3V8h-2v2c-1.7 0-3 1.3-3 3s1.3 3 3 3h2c.6 0 1 .4 1 1s-.4 1-1 1h-2c-.6 0-1-.4-1-1h-2c0 1.7 1.3 3 3 3v2h2v-2c1.7 0 3-1.3 3-3s-1.3-3-3-3h-2c-.6 0-1-.4-1-1s.4-1 1-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M.1 4.6V22h11v-2h-9V7h5V2h7v4h2V0H4.7zm2.4.4 2.6-2.6V5z"
  })));
};
export default SvgPaymentsReports;